import React from 'react';
import Select, { GroupBase, Props, StylesConfig } from 'react-select';
import { SelectOption } from 'ud-form/components/select/component';
import { theme } from 'styles/theme/theme';

export type UDSelectProps<isMulti extends boolean = boolean, Group extends GroupBase<SelectOption> = GroupBase<SelectOption>> = Omit<
  Props<SelectOption, isMulti, Group>,
  'hideSelectedOptions' | 'isSearchable' | 'styles'
>;

interface IProps extends UDSelectProps<false> {
  styledEachOption?: boolean;
}

function Selector(props: IProps) {
  const { styledEachOption } = props;
  const style: StylesConfig<SelectOption<any, any>, false, GroupBase<SelectOption<any, any>>> | undefined = {
    option: (provided, state) => {
      return { ...provided, fontFamily: styledEachOption && state.data.value };
    },

    menu: (base) => {
      return {
        ...base,
        zIndex: 9999,
        background: theme.colors.SurfaceCultured10,
      };
    },

    control: (base) => {
      return {
        ...base,
        background: theme.colors.SurfaceCultured10,
        borderColor: 'transparent',
        borderRadius: '8px',
        width: '100%',
        minHeight: 32,
        ':hover': {
          borderColor: 'transparent',
        },
      };
    },

    valueContainer: (base, state) => {
      const font = state.getValue()[0]?.value ?? 'Open Sans, sans-serif';
      return {
        ...base,
        fontFamily: styledEachOption && font,
        fontSize: 11,
      };
    },

    indicatorSeparator: (base) => {
      return {
        ...base,
        // height: '16px',
        marginBlock: 8,
        borderRadius: 1,
        backgroundColor: theme.colors.DarkBlue100,
      };
    },

    dropdownIndicator: (base) => {
      return {
        ...base,
        svg: {
          color: theme.colors.Gray96,
          width: '16px',
          height: '16px',
          padding: 2.5,
          marginInline: 4,
        },
        padding: 0,
      };
    },
  };

  return (
    <Select
      {...props}
      isSearchable={false}
      styles={style}
      theme={(selectTheme) => ({
        ...selectTheme,
        colors: {
          ...selectTheme.colors,
          // Оттенки для hover и выделения. У react-select 25 — самый бледный,
          // 75 — ближайший к primary; в подобранных на глаз значениях порядок был
          // обратный, поэтому берём шкалу DarkYellow по возрастанию насыщенности.
          primary75: theme.colors.DarkYellow300,
          primary50: theme.colors.DarkYellow200,
          primary25: theme.colors.DarkYellow100,
          primary: theme.colors.AccentNaplesYellow,
        },
      })}
    />
  );
}

export default Selector;
